/* demo:
import FormInput from 'src/common/components/Form/FormInput';

<FormInput
  label='活动名称'
  name='title'
  maxLength={50}
  allowClear
  rules={[{ required: true, whitespace: true, message: '请输入活动名称' }]}
  formItemConfig={{ className: 'mr-20' }}
  placeholder='请输入活动名称'
/>
*/
import { FC } from 'react';
import { Form, Input } from 'antd';
import { FormInputProps } from './ts-config';

const FormInput: FC<FormInputProps> = ({
  label,
  name,
  rules = [],
  placeholder = `请输入${label || ''}`,
  minLength,
  maxLength,
  onClickInput,
  prefix,
  allowClear = false,
  formItemConfig = {},
  config = {},
}) => {
  return (
    <Form.Item
      name={name}
      label={label}
      // 如果传入有规则，则默认添加字符串不能为空格的规则
      rules={rules}
      {...formItemConfig}
    >
      <Input
        minLength={minLength}
        maxLength={maxLength}
        prefix={prefix}
        placeholder={placeholder}
        autoComplete={config?.autoComplete || 'off'}
        allowClear={allowClear}
        {...config}
        onClick={() => onClickInput && onClickInput()}
      />
    </Form.Item>
  );
};

export default FormInput;
